import React from 'react';
import SettingButton from './SettingButton';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import Editable from '../common_components/Editable';

@injectIntl
@inject('membersStore', 'rootStore')
@observer
export default class SkillSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = { edition: false, currentSkill: null };
  }

  componentDidMount() {
    const { member, membersStore } = this.props;
    const customSkill = membersStore.getCustomSkill(member.custom_skill_id);
    if (customSkill != undefined)
      this.setState({
        currentSkill: customSkill.id,
      });
  }

  render() {
    let { membersStore, member, intl } = this.props;
    const skill = membersStore.getCustomSkill(member.custom_skill_id);

    return (
      <div className="role-container">
        <h5>{intl.formatMessage({ id: 'skill' })}: </h5>
        {member.skill != 'custom' ? (
          <h5>{intl.formatMessage({ id: member.skill })}</h5>
        ) : (
          <span>
            {!this.state.edition ? (
              <Select.Creatable
                noResultsText={intl.formatMessage({ id: 'no_results_message' })}
                disabled={!membersStore.canManage}
                clearable={false}
                shouldKeyDownEventCreateNewOption={({ keyCode }) =>
                  keyCode == 9 || keyCode == 13
                }
                multi={false}
                onChange={e => {
                  membersStore.handleCustomSkill(member.id, e.labelKey);
                  this.setState({ currentSkill: e.labelKey, edition: false });
                }}
                options={membersStore.features.customSkills.map(opt => ({
                  label: opt.name,
                  labelKey: opt.id,
                  value: opt.name,
                }))}
                onNewOptionClick={async e => {
                  if (membersStore.confirm()) {
                    const id = membersStore.createCustomSkill(
                      member.id,
                      e.value,
                    );
                    this.setState({ currentSkill: id });
                  }
                }}
                placeholder={intl.formatMessage({
                  id: 'select_custom_skill',
                })}
                value={
                  skill == undefined
                    ? intl.formatMessage({
                        id: 'select_custom_skill',
                      })
                    : skill.name
                }
                autoFocus
                promptTextCreator={label =>
                  `${intl.formatMessage({
                    id: 'create_custom_skill',
                  })} ${label}`
                }
              />
            ) : (
              <Editable
                value={skill != undefined ? skill.name : ''}
                required
                placeholder={intl.formatMessage({ id: 'edit_skill' })}
                canDelete={true}
                canEdit={true}
                onEdit={value => {
                  membersStore.editCustomSkill({
                    id: skill.id,
                    name: value,
                  });
                  this.setState({ currentSkill: skill.id, edition: false });
                }}
                maxLength={200}
              />
            )}
          </span>
        )}
        &nbsp;&nbsp;
        {!membersStore.canManage ? null : (
          <div id="setting-button-container">
            {member.skill == 'custom' && this.state.edition && (
              <i
                title={intl.formatMessage({ id: 'delete' })}
                className="btn btn-default fa fa-trash"
                style={{ border: 0 }}
                onClick={() => {
                  if (membersStore.confirm())
                    membersStore.deleteCustomSkill({
                      id: this.state.currentSkill,
                    });
                  this.setState({ edition: false, currentSkill: null });
                }}
              />
            )}
            &nbsp;&nbsp;
            {member.skill == 'custom' && this.state.currentSkill && (
              <React.Fragment>
                <i
                  title={intl.formatMessage({
                    id: `${!this.state.edition ? 'edit' : 'cancel'}`,
                  })}
                  style={{ border: 0 }}
                  className={`btn btn-default ${
                    !this.state.edition ? 'fa fa-pencil' : 'fa fa-close'
                  }`}
                  onClick={() =>
                    this.setState({ edition: !this.state.edition })
                  }
                />
                &nbsp;&nbsp;
              </React.Fragment>
            )}
            <SettingButton
              options="skills"
              member={member}
              handle={membersStore.handleSkill}
            />
          </div>
        )}
      </div>
    );
  }
}
